import { useEffect } from 'react';
import type { Invitation } from '@gcv/shared';
import { useQuery } from '@tanstack/react-query';

import { BanksApi } from 'api';
import { getFiDispensaryStore } from 'stores/FiDispensaryStore';
import { INVITED_DISPENSARIES_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useInvitedDispensaries({
  shouldNotifyOnChange = true
}: { shouldNotifyOnChange?: boolean } = {}) {
  const bankApi = new BanksApi();
  const bankDispensaryStore = getFiDispensaryStore();
  const { userBankId } = useUser();

  const fallback = [] as Invitation[];

  const { data: invitedDispensaries = fallback, isLoading: isLoadingInvitedDispensaries } = useQuery({
    enabled: !!userBankId.length,
    queryKey: [INVITED_DISPENSARIES_KEY, userBankId],
    queryFn: () => bankApi.getInvitedDispensaries(userBankId),
    ...(!shouldNotifyOnChange && { notifyOnChangeProps: [] })
  });

  useEffect(() => {
    if (invitedDispensaries?.length) {
      bankDispensaryStore.setInvitedDispensaries(invitedDispensaries);
    }
  }, [invitedDispensaries]);

  return { invitedDispensaries, isLoadingInvitedDispensaries };
}
